module.exports = "data:image/gif;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWcvYWRvcm5vMS5mN2M2Y2I1My5naWYiOw=="